var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 363.81 363.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-19{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#690a6e;}.cls-5{fill:#0a010a;}.cls-6{fill:url(#radial-gradient);}.cls-7{fill:url(#radial-gradient-2);}.cls-8{fill:#fff;}.cls-17,.cls-19,.cls-26,.cls-8{mix-blend-mode:overlay;}.cls-9{fill:url(#radial-gradient-3);}.cls-10{clip-path:url(#clip-path-2);}.cls-11{opacity:0.55;}.cls-12{fill:url(#radial-gradient-4);}.cls-13{fill:#00643d;}.cls-14{fill:#200321;}.cls-15{fill:#080108;}.cls-16{fill:url(#radial-gradient-5);}.cls-17{opacity:0.4;fill:url(#linear-gradient);}.cls-18{fill:#35ff61;}.cls-19{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.cls-20{fill:url(#radial-gradient-6);}.cls-21{mix-blend-mode:multiply;opacity:0.3;fill:url(#linear-gradient-2);}.cls-22{fill:url(#radial-gradient-7);}.cls-23{fill:#eaeaea;}.cls-24{fill:#707070;}.cls-25{fill:url(#linear-gradient-3);}.cls-26{opacity:0.8;fill:url(#linear-gradient-4);}.cls-27{fill:#494949;}.cls-28{fill:url(#radial-gradient-8);}.cls-29{fill:url(#radial-gradient-9);}.cls-30{fill:url(#radial-gradient-10);}.cls-31{fill:url(#radial-gradient-11);}.cls-32{fill:url(#radial-gradient-12);}.cls-33{fill:url(#radial-gradient-13);}.cls-34{clip-path:url(#clip-path-3);}.cls-35{fill:url(#radial-gradient-14);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.41,
    y: 0.24,
    width: 363.81,
    height: 363.81
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 652.33,
    cy: 171.65,
    r: 207.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 803.35, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#004b26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005026"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 652.31,
    cy: 227.74,
    r: 195.41,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 729.53,
    cy: -9.9,
    r: 388.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 803.35, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358c61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#358061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357b61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-89.54,112.06l27-15.58a7.68,7.68,0,0,1,7,0l1.6.93c4.46,2.59,11.73,2.59,16.24,0L23.47,62.07c4.49-2.6,4.51-6.81.05-9.4l-1.6-.93c-1.92-1.12-1.91-2.93,0-4.05l27-15.57c6.67-3.85,17.5-3.85,24.14,0L391.64,217.26c6.63,3.86,6.6,10.13-.07,14L253.11,311.18c-6.68,3.86-17.52,3.86-24.15,0L-89.62,126.05C-96.26,122.19-96.22,115.91-89.54,112.06Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 152.24,
    cy: 170.8,
    r: 207.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -10.26,
    cy: 188.4,
    r: 18.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -71.09,
    y1: 138.26,
    x2: 115.47,
    y2: 138.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f8f8f9",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#dadcdf",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced0d4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 163.75,
    cy: 225.66,
    r: 9.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 350.48,
    y1: 286.58,
    x2: 234.49,
    y2: 234.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebc5e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cca9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b392b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a484ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9f7fa8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 245.22,
    cy: 227.41,
    r: 50.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 292.86,
    y1: 203.55,
    x2: 394.76,
    y2: 334.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 379.65,
    y1: 213.37,
    x2: 415.59,
    y2: 261.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 185.06,
    cy: 212.75,
    r: 9.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 195.46,
    cy: 206.71,
    r: 9.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 202.75,
    cy: 200.84,
    r: 8.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 217.26,
    cy: 194.02,
    r: 9.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 227.33,
    cy: 188.14,
    r: 7.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 237.24,
    cy: 180.87,
    r: 10.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 443.4,
    y: 0.24,
    width: 363.81,
    height: 363.81
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 506.6,
    cy: 116.02,
    r: 169.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.37,285.12,342,273.2c1.47-.85,2.67-.16,2.67,1.53a5.82,5.82,0,0,1-2.65,4.59l-20.64,11.92c-1.47.85-2.67.17-2.68-1.52A5.88,5.88,0,0,1,321.37,285.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321.37,284.71,342,272.79c1.47-.85,2.67-.16,2.67,1.53a5.84,5.84,0,0,1-2.65,4.6l-20.64,11.92c-1.47.85-2.67.17-2.68-1.52A5.89,5.89,0,0,1,321.37,284.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-95.52,108.58,42.94,28.64c10-5.78,26.19-5.78,36.15,0L397.67,213.78c10,5.79,9.9,15.16-.11,20.95L259.1,314.67c-10,5.78-26.2,5.78-36.16,0L-95.64,129.52C-105.6,123.74-105.53,114.36-95.52,108.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-95.64,129.52,222.94,314.66c10,5.79,26.15,5.79,36.16,0l138.46-79.94c5-2.91,7.55-6.73,7.54-10.54l0,17.34c0,3.82-2.5,7.64-7.54,10.54L259.15,332c-10,5.78-26.2,5.78-36.16,0L-95.59,146.87c-5-2.87-7.42-6.63-7.43-10.4q0-8.67,0-17.34C-103.06,122.89-100.59,126.65-95.64,129.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M-103.07,120.51c0,3.77,2.47,7.54,7.43,10.42L222.94,316.07c10,5.79,26.15,5.79,36.16,0l138.46-79.94c5.34-3.09,7.82-7.19,7.48-11.23-.28,3.57-2.76,7.09-7.48,9.82L259.1,314.67c-10,5.78-26.2,5.78-36.16,0L-95.64,129.52c-4.65-2.7-7.08-6.18-7.37-9.71,0,.2,0,.41-.06.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-89.54,112.06l27-15.58a7.68,7.68,0,0,1,7,0l1.6.93c4.46,2.59,11.73,2.59,16.24,0L23.47,62.07c4.49-2.6,4.51-6.81.05-9.4l-1.6-.93c-1.92-1.12-1.91-2.93,0-4.05l27-15.57c6.67-3.85,17.5-3.85,24.14,0L391.64,217.26c6.63,3.86,6.6,10.13-.07,14L253.11,311.18c-6.68,3.86-17.52,3.86-24.15,0L-89.62,126.05C-96.26,122.19-96.22,115.91-89.54,112.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "-100.56 117.83 57.91 22.78 405.05 224.91 243.61 318.81 -100.56 117.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "-100.56 117.83 57.91 22.78 80.17 35.74 -78.5 130.72 -100.56 117.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M-64.77,129.29,2.3,89.16a3.72,3.72,0,0,1,3.46,0L8,90.48c1,.57,1,1.49.08,2L-59,132.64a3.72,3.72,0,0,1-3.45,0l-2.2-1.29C-65.66,130.76-65.7,129.84-64.77,129.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M-42.24,142.44l30.78-18.37a3.74,3.74,0,0,1,3.46,0L.41,129c1,.57,1,1.48.08,2l-30.8,18.37a3.72,3.72,0,0,1-3.45,0l-8.39-4.9C-43.13,143.91-43.17,143-42.24,142.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M51.83,69,82.89,50.4a3.78,3.78,0,0,1,3.48,0l2.23,1.3c1,.57,1,1.49.08,2.05L57.61,72.34a3.78,3.78,0,0,1-3.48,0L51.91,71C50.93,70.45,50.89,69.53,51.83,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M66.5,77.52,97.58,59a3.81,3.81,0,0,1,3.49,0l8.46,4.93c1,.57,1,1.49.07,2L78.5,84.51a3.78,3.78,0,0,1-3.48,0l-8.44-4.92C65.59,79,65.56,78.08,66.5,77.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: -32.78,
    y1: 157.41,
    x2: 126.27,
    y2: 62.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M-18.81,156.12l67.23-40.06a3.76,3.76,0,0,1,3.47,0l2.22,1.3c1,.57,1,1.49.08,2l-67.26,40.06a3.75,3.75,0,0,1-3.45,0l-2.21-1.29C-19.71,157.59-19.74,156.68-18.81,156.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M-10.85,160.77,20,142.41a3.74,3.74,0,0,1,3.46,0l2.21,1.29c1,.57,1,1.48.08,2L-5.11,164.12a3.72,3.72,0,0,1-3.45,0l-2.21-1.29C-11.75,162.24-11.79,161.32-10.85,160.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3.74,169.29l30.85-18.35a3.76,3.76,0,0,1,3.47,0l8.42,4.91c1,.57,1,1.48.07,2L15.68,176.26a3.74,3.74,0,0,1-3.46,0l-8.4-4.9C2.84,170.76,2.81,169.84,3.74,169.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M98.07,95.91,129.2,77.37a3.78,3.78,0,0,1,3.49,0l2.23,1.29c1,.58,1,1.5.07,2.06L103.85,99.28a3.81,3.81,0,0,1-3.49,0L98.14,98C97.16,97.39,97.12,96.47,98.07,95.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M112.74,104.47,143.9,85.94a3.81,3.81,0,0,1,3.49,0l8.47,4.93c1,.57,1,1.49.07,2.06l-31.17,18.52a3.81,3.81,0,0,1-3.49,0l-8.45-4.92C111.84,105.94,111.8,105,112.74,104.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 13.19,
    y1: 184.25,
    x2: 172.63,
    y2: 89.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27.18,183l67.4-40a3.76,3.76,0,0,1,3.48,0l2.22,1.29c1,.57,1,1.49.07,2l-67.42,40a3.77,3.77,0,0,1-3.46,0L27.26,185C26.28,184.44,26.25,183.53,27.18,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M35.15,187.63l30.9-18.33a3.76,3.76,0,0,1,3.47,0l2.22,1.29c1,.57,1,1.49.08,2L40.9,191a3.77,3.77,0,0,1-3.46,0l-2.21-1.3C34.25,189.09,34.21,188.18,35.15,187.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.75,196.16l30.93-18.32a3.74,3.74,0,0,1,3.47,0l8.43,4.91c1,.57,1,1.49.07,2L61.7,203.13a3.74,3.74,0,0,1-3.46,0l-8.41-4.91C48.85,197.62,48.82,196.71,49.75,196.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M144.34,122.88l31.21-18.51a3.81,3.81,0,0,1,3.49,0l2.23,1.3c1,.57,1,1.49.07,2l-31.22,18.51a3.76,3.76,0,0,1-3.48,0l-2.23-1.29C143.43,124.35,143.39,123.44,144.34,122.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M159,131.44l31.23-18.5a3.83,3.83,0,0,1,3.5,0l8.48,4.94c1,.57,1,1.49.07,2l-31.26,18.49a3.81,3.81,0,0,1-3.49,0l-8.46-4.93C158.12,132.91,158.08,132,159,131.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 59.19,
    y1: 211.12,
    x2: 219.04,
    y2: 116.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M73.22,209.86l67.56-39.94a3.82,3.82,0,0,1,3.48,0l2.23,1.3c1,.57,1,1.49.07,2L79,213.22a3.77,3.77,0,0,1-3.46,0l-2.22-1.29C72.31,211.32,72.28,210.41,73.22,209.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M81.19,214.51l31-18.3a3.82,3.82,0,0,1,3.48,0l2.21,1.3c1,.57,1,1.48.08,2l-31,18.29a3.77,3.77,0,0,1-3.46,0l-2.22-1.29C80.28,216,80.25,215.06,81.19,214.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M95.8,223l31-18.29a3.79,3.79,0,0,1,3.48,0l8.43,4.92c1,.57,1,1.48.07,2l-31,18.28a3.77,3.77,0,0,1-3.47,0l-8.42-4.91C94.9,224.51,94.87,223.6,95.8,223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M190.65,149.86l31.29-18.48a3.83,3.83,0,0,1,3.5,0l2.23,1.3c1,.57,1,1.49.07,2l-31.3,18.48a3.81,3.81,0,0,1-3.49,0l-2.23-1.3C189.73,151.34,189.7,150.42,190.65,149.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.35,158.43,236.66,140a3.82,3.82,0,0,1,3.51,0l8.48,4.94c1,.57,1,1.49.07,2l-31.34,18.46a3.78,3.78,0,0,1-3.49,0l-8.47-4.93C204.44,159.91,204.4,159,205.35,158.43Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 105.24,
    y1: 238.01,
    x2: 265.48,
    y2: 143.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M119.29,236.76,187,196.89a3.81,3.81,0,0,1,3.49,0l2.22,1.3c1,.57,1,1.48.07,2l-67.75,39.86a3.77,3.77,0,0,1-3.47,0l-2.22-1.29C118.38,238.22,118.35,237.31,119.29,236.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M127.26,241.41l31.07-18.27a3.82,3.82,0,0,1,3.48,0l2.22,1.29c1,.58,1,1.49.07,2L133,244.78a3.82,3.82,0,0,1-3.48,0l-2.21-1.29C126.36,242.88,126.33,242,127.26,241.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M141.89,250,173,231.7a3.79,3.79,0,0,1,3.48,0l8.44,4.93c1,.57,1,1.48.07,2L153.87,257a3.82,3.82,0,0,1-3.48,0L142,252C141,251.42,141,250.51,141.89,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237,176.87l31.36-18.45a3.85,3.85,0,0,1,3.51,0l2.23,1.3c1,.58,1,1.5.07,2.05l-31.38,18.45a3.83,3.83,0,0,1-3.5,0l-2.23-1.3C236.08,178.35,236.05,177.43,237,176.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M251.71,185.45,283.1,167a3.82,3.82,0,0,1,3.51,0L295.1,172c1,.57,1,1.49.07,2.05l-31.41,18.43a3.82,3.82,0,0,1-3.51,0l-8.47-4.94C250.79,186.92,250.76,186,251.71,185.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 151.32,
    y1: 264.92,
    x2: 311.96,
    y2: 170.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M165.4,263.68l67.9-39.8a3.81,3.81,0,0,1,3.49,0l2.23,1.3c1,.57,1,1.49.07,2l-67.93,39.8a3.8,3.8,0,0,1-3.47,0l-2.22-1.3C164.49,265.14,164.46,264.23,165.4,263.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M173.38,268.34l31.14-18.24a3.79,3.79,0,0,1,3.48,0l2.23,1.29c1,.58,1,1.49.07,2l-31.15,18.24a3.82,3.82,0,0,1-3.48,0l-2.22-1.3C172.47,269.8,172.44,268.89,173.38,268.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M188,276.89l31.16-18.23a3.81,3.81,0,0,1,3.49,0l8.45,4.93c1,.57,1,1.48.07,2L200,283.89a3.82,3.82,0,0,1-3.48,0l-8.43-4.93C187.11,278.35,187.08,277.44,188,276.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.39,203.9l31.44-18.42a3.88,3.88,0,0,1,3.51,0l2.24,1.31c1,.57,1,1.49.06,2.05l-31.45,18.41a3.85,3.85,0,0,1-3.51,0l-2.23-1.3C282.46,205.38,282.44,204.46,283.39,203.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M298.11,212.48l31.47-18.4a3.84,3.84,0,0,1,3.52,0l8.49,4.94c1,.58,1,1.5.06,2.06l-31.48,18.4a3.85,3.85,0,0,1-3.51,0l-8.48-4.94C297.19,214,297.16,213,298.11,212.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 197.45,
    y1: 291.86,
    x2: 358.48,
    y2: 197.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M211.54,290.62l68.07-39.73a3.83,3.83,0,0,1,3.5,0l2.23,1.3c1,.58,1,1.49.07,2L217.32,294a3.81,3.81,0,0,1-3.49,0l-2.22-1.29C210.63,292.08,210.6,291.17,211.54,290.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M219.54,295.29l31.21-18.21a3.84,3.84,0,0,1,3.49,0l2.23,1.3c1,.57,1,1.48.06,2l-31.22,18.21a3.84,3.84,0,0,1-3.49,0l-2.22-1.3C218.62,296.75,218.59,295.84,219.54,295.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M234.19,303.85l31.24-18.2a3.81,3.81,0,0,1,3.49,0l8.46,4.94c1,.57,1,1.48.06,2l-31.26,18.2a3.84,3.84,0,0,1-3.49,0l-8.43-4.93C233.28,305.31,233.25,304.4,234.19,303.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M329.81,231l31.52-18.39a3.87,3.87,0,0,1,3.52,0l2.24,1.3c1,.58,1,1.5.06,2l-31.53,18.39a3.82,3.82,0,0,1-3.51,0l-2.23-1.3C328.89,232.43,328.86,231.51,329.81,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M344.55,239.55l31.55-18.38a3.84,3.84,0,0,1,3.52,0l8.5,5c1,.58,1,1.5.06,2l-31.56,18.38a3.9,3.9,0,0,1-3.52,0l-8.49-4.95C343.63,241,343.6,240.1,344.55,239.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 243.61,
    y1: 318.82,
    x2: 405.04,
    y2: 224.91
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M-89.54,112.82l27-15.58a7.68,7.68,0,0,1,7,0l1.6.93c4.46,2.59,11.73,2.59,16.24,0L23.47,62.83c2.42-1.4,3.53-3.27,3.35-5.11-.15,1.58-1.26,3.14-3.35,4.35L-37.75,97.41c-4.51,2.6-11.78,2.6-16.24,0l-1.6-.93a7.68,7.68,0,0,0-7,0l-27,15.58c-3.52,2-5.17,4.73-5,7.4C-94.38,117-92.72,114.66-89.54,112.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M21.94,48.45l27-15.57c6.67-3.85,17.5-3.85,24.14,0L391.64,218c3.14,1.83,4.77,4.19,4.92,6.59.18-2.65-1.45-5.33-4.92-7.35L73.06,32.12c-6.64-3.85-17.47-3.85-24.14,0l-27,15.57a2.27,2.27,0,0,0-1.39,2.42A2.71,2.71,0,0,1,21.94,48.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-21.65,77.2-2.27,66a3.81,3.81,0,0,1,3.42,0,1,1,0,0,1,0,2L-18.24,79.18a3.75,3.75,0,0,1-3.42,0A1,1,0,0,1-21.65,77.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.78,309a2.76,2.76,0,0,0-1.26,2.19c0,.8.57,1.12,1.27.72a2.78,2.78,0,0,0,1.26-2.19C284.05,308.92,283.49,308.6,282.78,309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.28,304.68a2.79,2.79,0,0,0-1.27,2.19c0,.8.58,1.12,1.28.72a2.78,2.78,0,0,0,1.26-2.19C291.55,304.59,291,304.27,290.28,304.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.78,300.35a2.79,2.79,0,0,0-1.27,2.19c0,.8.58,1.12,1.28.72a2.81,2.81,0,0,0,1.26-2.19C299.05,300.26,298.48,299.94,297.78,300.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.28,296a2.76,2.76,0,0,0-1.27,2.19c0,.8.57,1.12,1.28.72a2.79,2.79,0,0,0,1.26-2.19C306.55,295.93,306,295.61,305.28,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358.11,265.51a2.79,2.79,0,0,0-1.27,2.2c0,.8.57,1.12,1.28.72a2.83,2.83,0,0,0,1.26-2.19C359.38,265.43,358.81,265.11,358.11,265.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M282.78,308.6a2.78,2.78,0,0,0-1.26,2.19c0,.8.57,1.12,1.27.72a2.76,2.76,0,0,0,1.26-2.18C284.05,308.52,283.49,308.19,282.78,308.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M290.28,304.27a2.79,2.79,0,0,0-1.27,2.19c0,.8.58,1.12,1.28.72a2.76,2.76,0,0,0,1.26-2.18C291.55,304.19,291,303.86,290.28,304.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M297.78,299.94a2.79,2.79,0,0,0-1.27,2.19c0,.8.58,1.12,1.28.72a2.77,2.77,0,0,0,1.26-2.18C299.05,299.85,298.48,299.54,297.78,299.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M305.28,295.61A2.77,2.77,0,0,0,304,297.8c0,.8.57,1.13,1.28.72a2.77,2.77,0,0,0,1.26-2.18C306.55,295.52,306,295.21,305.28,295.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M358.11,265.11a2.76,2.76,0,0,0-1.27,2.19c0,.8.57,1.13,1.28.72a2.8,2.8,0,0,0,1.26-2.19C359.38,265,358.81,264.71,358.11,265.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.38,196.8-28.9,175.28c-1.47-.85-2.66-.16-2.67,1.53a5.86,5.86,0,0,0,2.66,4.59L8.36,202.93c1.47.84,2.67.17,2.68-1.52A5.87,5.87,0,0,0,8.38,196.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M8.38,196.09-28.9,174.57c-1.47-.85-2.66-.16-2.67,1.53a5.88,5.88,0,0,0,2.66,4.6L8.36,202.22c1.47.85,2.67.17,2.68-1.52A5.87,5.87,0,0,0,8.38,196.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-71.09,143.79,115.47,252.21V49.79L79.09,28.64c-10-5.78-26.14-5.78-36.15,0l-114,65.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274,175l-23.16-13.37c-6.39-3.69-16.73-3.7-23.09,0L137.65,214c-6.35,3.7-6.31,9.69.09,13.38l23.15,13.37c6.4,3.69,16.73,3.69,23.08,0l90.11-52.37C280.44,184.67,280.4,178.68,274,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M274,175l-23.16-13.37c-6.39-3.69-16.73-3.7-23.09,0L137.65,214c-6.35,3.7-6.31,9.69.09,13.38l23.15,13.37c6.4,3.69,16.73,3.69,23.08,0l90.11-52.37C280.44,184.67,280.4,178.68,274,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M174.39,224.41,168,220.73a6.13,6.13,0,0,0-5-.25l-1.13-.65a9.13,9.13,0,0,0-8.27,0c-2.27,1.32-2.26,3.47,0,4.79l1.13.65c-1,.88-.9,2.09.46,2.87l6.37,3.68a6.06,6.06,0,0,0,5.47,0l7.29-4.24C175.91,226.71,175.91,225.29,174.39,224.41Zm-18-.11-1.09-.63c-1.38-.8-1.39-2.09,0-2.89a5.47,5.47,0,0,1,5,0l1.09.63Zm9.74,3.94L164.6,227a3.7,3.7,0,0,1-2.49-.32,1,1,0,0,1,0-2,3.71,3.71,0,0,1,3.37,0c.68.39.86,1,.56,1.44l2.2.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "369.73 243.85 293.17 199.36 183.78 262.93 259.98 307.21 369.73 243.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M306.31,191.56a4.66,4.66,0,0,0-4.24,0L183.52,260.45c-1.17.68-1.16,1.77,0,2.45a4.62,4.62,0,0,0,4.22,0L306.31,194A1.29,1.29,0,0,0,306.31,191.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M306.61,191.74a4.66,4.66,0,0,0-4.24,0l-118.55,68.9a1.29,1.29,0,0,0,0,2.45,4.68,4.68,0,0,0,4.22,0l118.56-68.9A1.3,1.3,0,0,0,306.61,191.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M202,243.16l110-63.93c-5.75,3.34-10.35,9.1-13.3,16.84L188.74,260C191.7,252.27,196.29,246.5,202,243.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M304,186.48c-.62-.52-1.23-1-1.84-1.51L202,243.16c-.24.14-.47.32-.71.47a25.3,25.3,0,0,1,13,1.48l84.38-49A38.06,38.06,0,0,1,304,186.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M201.17,243.65l110-63.93c8.83-5.14,20.19-4.53,31.92,2.25a61.74,61.74,0,0,1,7.88,5.45c14.95,12.09,22.5,24.59,29.81,36.67,7.63,12.64,14.85,24.59,29.8,35.78a91.72,91.72,0,0,0,8.84,5.84c15.19,8.77,31.49,12.05,43.51,8.37a27.73,27.73,0,0,0,6-2.58l-110,63.94a28.76,28.76,0,0,1-6,2.58c-12,3.68-28.33.39-43.51-8.38a85.9,85.9,0,0,1-8.84-5.84c-15-11.19-22.18-23.14-29.81-35.78-7.3-12.08-14.85-24.57-29.8-36.66a62.56,62.56,0,0,0-7.88-5.46C221.36,239.13,210,238.51,201.17,243.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M342.3,182.14a60.73,60.73,0,0,1,7.88,5.45c14.95,12.09,22.5,24.58,29.8,36.66,7.64,12.64,14.86,24.59,29.81,35.79a87.47,87.47,0,0,0,8.84,5.83c14.3,8.26,29.59,11.65,41.36,8.95-11.65,2.37-26.57-1-40.55-9.11a91.72,91.72,0,0,1-8.84-5.84c-15-11.19-22.17-23.14-29.8-35.78C373.49,212,365.94,199.51,351,187.42a61.74,61.74,0,0,0-7.88-5.45c-8.87-5.12-17.51-6.72-25-5C325.41,175.55,333.75,177.2,342.3,182.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M295.33,203.66l-63,36.6c.58.24,1.16.5,1.75.77l63-36.61C296.49,204.15,295.91,203.89,295.33,203.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M328.92,185.91c-.58-.27-1.16-.52-1.74-.76l-9.56,5.56c.58.23,1.16.49,1.74.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M308.86,211.91c-.6-.48-1.19-.95-1.79-1.4l-63,36.61c.6.45,1.19.91,1.79,1.4l.08.06,63-36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M331.23,199l9.56-5.56-.08-.07c-.6-.48-1.19-1-1.79-1.4l-9.57,5.56c.6.45,1.2.92,1.79,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M320.4,222.76l-63,36.61c.6.65,1.18,1.3,1.75,2l63-36.61C321.58,224.07,321,223.41,320.4,222.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M354,206.21c-.56-.65-1.15-1.3-1.74-2l-9.57,5.56c.6.65,1.18,1.31,1.75,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M330.47,235.59l-63,36.6c.45.66.89,1.31,1.32,2l63-36.6C331.35,236.9,330.92,236.24,330.47,235.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M354.07,224.6l9.56-5.56-1.31-2-9.57,5.56C353.2,223.29,353.64,224,354.07,224.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M338.66,248.58l-.15-.25-63,36.61.15.24c.36.59.72,1.18,1.07,1.77l63-36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M360.94,235.63c.36.59.72,1.18,1.07,1.77l9.57-5.56-1.07-1.77-.15-.25h0l-9.56,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M346.72,261.37l-63,36.61,1.37,1.95,63-36.6C347.62,262.68,347.17,262,346.72,261.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M356.7,273.9l-63,36.6c.59.63,1.19,1.25,1.82,1.88l63-36.61C357.9,275.15,357.29,274.53,356.7,273.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M370,285.49l-63,36.6c.61.44,1.22.87,1.84,1.28l63-36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M382.07,292.75l-63,36.6c.61.31,1.23.6,1.84.89l63-36.61C383.3,293.35,382.68,293.05,382.07,292.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M331.1,334.13l1.82.52,63-36.61c-.6-.16-1.21-.34-1.82-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M469.38,271.21l-110,63.94c8.33-4.84,13.4-13.83,14.92-26.29l110-63.93C482.78,257.38,477.7,266.37,469.38,271.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M189.88,218.74l-16.15-8.33,5-2.83a6.74,6.74,0,0,1,4-.78,9.24,9.24,0,0,1,3.2.95l0,0c1.68.84,2.38,1.73,2.1,2.65a8.6,8.6,0,0,1,2.86-.09,9.3,9.3,0,0,1,3,1l.05,0c1.42.71,2.21,1.45,2.37,2.23s-.32,1.51-1.48,2.19Zm-5.6-9-.05,0a2.58,2.58,0,0,0-2.58,0l-1.75,1,2.81,1.44,1.69-1C185.25,210.7,185.21,210.22,184.28,209.74Zm6.43,2.84-.05,0a2.74,2.74,0,0,0-2.77,0l-2,1.19,3,1.54,2.07-1.22C191.77,213.59,191.7,213.09,190.71,212.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M199.72,212.9l-16.15-8.09,7.57-4.3,3.72,1.82-5,2.86,2.45,1.21,4.5-2.6,3.53,1.73-4.5,2.63,2.58,1.28,5-3,3.87,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M210.93,206.26l-12.28-6-2.76,1.59L192,200l8-4.57,3.86,1.84-2.74,1.57,12.28,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M221.15,200.19,205,192.61l2.31-1.32,12.07,1.83-8.43-3.9,2.41-1.37,16.1,7.4-2.11,1.25-12.71-1.93,8.93,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M236.52,188.84a2,2,0,0,1-.81,3.06,9.77,9.77,0,0,1-5.77.84,22.26,22.26,0,0,1-7.28-1.94l0,0c-2.33-1.06-3.84-2.22-4.54-3.46s-.39-2.23.93-3a9.94,9.94,0,0,1,5.66-.8,22.16,22.16,0,0,1,7.15,1.86l0,0Q235.37,187,236.52,188.84Zm-7.75,1.54a4.68,4.68,0,0,0,2.88-.34.89.89,0,0,0,.3-1.48,6.07,6.07,0,0,0-2.46-1.73l0,0a12.39,12.39,0,0,0-3.67-1,4.8,4.8,0,0,0-2.84.33.9.9,0,0,0-.33,1.47,5.78,5.78,0,0,0,2.41,1.74l0,0A12.19,12.19,0,0,0,228.77,190.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M243.07,187.31l-19-5.53,2.47-1.41,10.68,3.22-7.64-5,2-1.13,10.84,3.1-7.76-4.8,2.35-1.34L250.4,183l-2,1.17-11-3.09,7.65,5.07Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M367.39,83.87l275-158.75a5.07,5.07,0,0,1,3-.7l1.56.14,1.55.14,1.34.12a5.08,5.08,0,0,0-3,.71L371.84,84.27c-3.22,1.86-4.82,6.75-3.56,10.88L431.57,302.8c.88,2.86,2.9,4.63,5.13,4.83l-4.45-.4c-2.23-.2-4.25-2-5.12-4.83L363.83,94.75C362.57,90.62,364.17,85.72,367.39,83.87Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0dbec2b19b5cc41dfd9213e81d4b5d16.svg";
export { ForwardRef as ReactComponent };